/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type { GetHistoryParams, PagedModelTouchpointVersionHistoryDto } from "../schemas";

import { customInstance } from "../../config/mutator";

export const getTouchpointVersionHistory = () => {
  /**
   * Required authority: PERM_TOUCHPOINT_READ
   */
  const getHistory = (params?: GetHistoryParams) => {
    return customInstance<PagedModelTouchpointVersionHistoryDto>({
      url: `/api/touchpoint-version-history`,
      method: "GET",
      params,
    });
  };
  return { getHistory };
};
export type GetHistoryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersionHistory>["getHistory"]>>
>;
